import React, { type FC } from 'react';

import ModalTransition from '@atlaskit/modal-dialog/modal-transition';

import { LoadableLazy } from '@confluence/loadable';

type LiveDocConversionBlockedModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

const LiveDocConversionBlockedModalContent = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LiveDocConversionBlockedModal" */ './LiveDocConversionBlockedModal.tsx'
			)
		).LiveDocConversionBlockedModal,
});

export const LiveDocConversionBlockedModal: FC<LiveDocConversionBlockedModalProps> = ({
	isOpen,
	onClose,
}) => {
	return (
		<ModalTransition>
			{isOpen ? <LiveDocConversionBlockedModalContent onClose={onClose} /> : null}
		</ModalTransition>
	);
};
